module.exports = __webpack_public_path__ + "static/media/future_of_investment.167feb39.png";